export default "__VITE_ASSET__C0Wpf$au__"